

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Card, CardContent, Container, Divider, Modal, Typography, Grid, Input, makeStyles } from '@material-ui/core';
import { Button } from '@fifth-gear-tech/common-components/dist/components';
import { ButtonType, Colors } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';

import { RemnantLabel } from '../../labels';
import utils from '../../utils';
import ColorBandSelector from '../ColorBandSelector';

const useStyles = makeStyles({
    card: {
        marginTop: '1%', width: '50%',
        '&:focus': { outline: 'none', boxShadow: 'none' },
    },
    modalHeader: { marginBottom: '0.5rem', fontWeight: '500' },
    divider: { margin: '1rem' },
    controlSection: { width: '85%', height: '60%', border: '1px solid gray', borderRadius: '5px', padding: '0.5rem' },
    footer: { display: 'flex', justifyContent: 'space-between', width: '65%', marginTop: '2rem' },
    openButton: { width: 'calc(100% - 2rem)', padding: '0.7rem', marginTop: '1rem', textAlign: 'center', marginLeft: '0 !important' },
});

const PrintRemnantLabelModal = (props) => {
    const { jobId, filtered, setRemnantLabels, resetLabels, togglePrintMode, remnantFields, colors } = props;
    // react
    const [open, setOpen] = useState(false);
    const [qty, setQty] = useState(1);
    const [samplePart, setSamplePart] = useState(null);
    const [colorBand, setColorBand] = useState([]); // this is an array for some reason
    // mui
    const sx = useStyles();

    const remPartData = utils.remnant.partToRemnant(samplePart, 'r_*');

    useEffect(() => {
        if (open && filtered.length > 0) {
            const remLabels = [];
            for (let i = 0; i < qty; i++) {
                const sample = samplePart || filtered[0];
                if (!samplePart) {
                    setSamplePart(sample);
                }
                remLabels.push(utils.remnant.partToRemnant(sample, `r_${i}`, colorBand));
            }
            setRemnantLabels(remLabels);
        }
    }, [qty, open, colorBand]);

    const handleClose = () => {
        togglePrintMode();
        setOpen(false);
        setQty(0);
        setRemnantLabels([]);
        resetLabels();
    };

    const handleOpen = () => {
        togglePrintMode();
        setOpen(true);
        setQty(1);
    };

    const handleQtyChange = (value) => {
        if (value > 0 && value <= 9) {
            setQty(value);
        } else {
            setQty(1);
        }
    };

    return (
        <div>
            <Modal open={open} onClose={handleClose} className='RemnantLabelModal' disableBackdropClick disableScrollLock>
                <Container align='center'>
                    <Card className={sx.card}>
                        <CardContent>
                            {/* header */}
                            <Typography variant='h5' className={sx.modalHeader}>Print Extra Remnant Labels</Typography>
                            <Divider className={sx.divider} />

                            <Grid container spacing={2}>
                                {/* job id */}
                                <Grid item xs={6}>
                                    <Typography variant='h6'>Job</Typography>
                                    <div className={sx.controlSection}>
                                        <Typography variant='body2'>{jobId}</Typography>
                                    </div>
                                </Grid>
                                {/* quantity */}
                                <Grid item xs={6}>
                                    <Typography variant='h6'>Quantity</Typography>
                                    <div className={sx.controlSection}>
                                        <Input type='number'
                                            // disableUnderline
                                            style={{ width: '50%', caretColor: 'transparent' }}
                                            value={qty} onChange={({ target: { value } }) => handleQtyChange(value)}
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <ColorBandSelector colors={colors} setColorBand={setColorBand} />

                            {/* footer buttons */}
                            <div className={sx.footer}>
                                <Button colorTheme={Colors.Orange} type={ButtonType.Dashboard} onClick={() => window.print()} label={'Print Remnants'} style={{ float: 'left' }} />
                                <Button colorTheme={Colors.Red} type={ButtonType.Close} label={'Close '} style={{ float: 'right' }} onClick={handleClose} />
                            </div>
                        </CardContent>
                    </Card>


                    {/* preview */}
                    <div style={{ marginTop: '1rem', zoom: '70%' }}>
                        <RemnantLabel {...{ ...props, remnantFields, part: remPartData, colors: colorBand }} />
                    </div>
                </Container>
            </Modal>

            <Button
                className={sx.openButton}
                colorTheme={Colors.Sage} type={ButtonType.Edit}
                label={<Typography variant='caption' style={{ fontWeight: '500', letterSpacing: '0.6px' }}>Print Extra Remnant Labels</Typography>}
                onClick={() => handleOpen()}
            />
        </div >
    );
};

PrintRemnantLabelModal.propTypes = {
    jobId: PropTypes.string,
    filter: PropTypes.object,
    filtered: PropTypes.array,
    setRemnantLabels: PropTypes.func,
    resetLabels: PropTypes.func,
    togglePrintMode: PropTypes.func,
    remnantFields: PropTypes.array,
    colors: PropTypes.array,
    part: PropTypes.object,
};

export default PrintRemnantLabelModal;